import { Suspense, LazyExoticComponent, ComponentType } from 'react';

type LazyComponentProps = {
  AsyncComponent: LazyExoticComponent<ComponentType<any>>;
};

function LazyComponent(props: LazyComponentProps) {
  const { AsyncComponent } = props;
  return (
    <Suspense fallback={<div />}>
      <AsyncComponent />
    </Suspense>
  );
}

export default LazyComponent;
